import permissionList from "./permissions-list/PermissionList.vue";
import RoleService from "../../services/roles/RoleService";

import permissionService from "../../services/permissions/permissionService";
import i18n from "../../i18n/index";

export default {
  components: {
    permissionList
  },
  data: () => ({
    value: "",
    dialog: false,
    hideList: false,
    roleItems: [],
    selectedRole: "",
    selections: [],
    permissionItems: [],
    loading: false,
    roleName: "",
    role: {
      id: null,
      name: ''
    },
    itemsData: []
  }),
  created() {
    this.getRoles();
  },

  watch: {
    selectedRole() {
      this.getPermissions();
    }
  },

  methods: {
    closeRole() {
      this.hideList = false;
      this.dialog = false;
      this.roleName = "";
      this.role = {
        id: null,
        name: ''
      }
    },
    saveRole() {
      if (this.role.name && this.role.name !== "") {
        RoleService.createRole(this.role.name, this.role.id)
          .then(response => {
            this.role.name = ''
            this.hideList = false;
            this.roleName = "";
            this.$refs.permissionList.searchRoles();
            this.$notify({
              group: "app",
              type: "success",
              text: i18n.t("permission.rol-alert-save")
            });
          })
          .catch(err => {
            throw err;
          });
      } else
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("permission.no-name-role")
        });
    },
    handleRole(role) {
      this.hiddenList = true;
      this.role = role;
    },
    getRoles() {
      RoleService.getRoles().then(response => {
        this.roleItems = response.data;
      });
    },

    getPermissions() {
      if (!this.selectedRole) return;

      this.permissionItems = [];
      this.selections = [];

      permissionService.getPermissions(this.selectedRole).then(result => {
        this.permissionItems = result.data;

        this.selections = this.permissionItems.flatMap(({ children }) => {
          if (children)
            return children.filter(child => child.have_permission === 1);
          return;
        });
      });
    },

    getCheckedOption(option) {
      if (option.children) {
        option.children = this.lodash.map(
          option.children,
          this.getCheckedOption
        );
      }

      return option;
    }
  }
};
